import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import getIsAdmin from '../utils/isAdmin';
import { fetchBuildInfo } from '../redux/slices/appSlice';

const BuildVersion = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const telegramUser = useSelector(state => state.telegram.telegramUser);
    const isAdmin = getIsAdmin(user, telegramUser);
    
    const { buildInfo, loading } = useSelector(state => state.app);

    useEffect(() => {
        // Более строгая проверка кэша
        if (buildInfo.hash && buildInfo.hash !== 'unknown' && buildInfo.hash !== 'dev') {
            console.log('Build info already loaded, skipping');
            return;
        }
        
        // Загружаем build info только если данные не загружены
        if (!buildInfo.hash || buildInfo.hash === 'unknown') {
            console.log('Loading build info...');
            dispatch(fetchBuildInfo());
        }
    }, [dispatch, buildInfo.hash]);

    // Показываем панель только админам
    if (!isAdmin) {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            bottom: '0',
            left: '0',
            right: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            color: '#fff',
            padding: '4px 8px',
            fontSize: '10px',
            fontFamily: 'monospace',
            zIndex: 9998,
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }}>
            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                <span>🔧 <strong>{buildInfo.version}</strong></span>
                <span>📦 <strong>v{buildInfo.appVersion}</strong></span>
                <span>📝 <strong>{buildInfo.shortHash}</strong></span>
                <span>⏰ {new Date(buildInfo.buildTime).toLocaleTimeString()}</span>
            </div>
            <div style={{ fontSize: '9px', opacity: 0.7 }}>
                Telesun App
            </div>
        </div>
    );
};

export default BuildVersion;
